<template>
  <div class="home_view">
    <!-- 南普陀寺 -->
    <main class="temple">
      <div class="box">
        <div class="txt">
          <img
            src="https://f.nanputuo.com/nanputuo/img/public/sy_bt1@2x.png"
            alt="南普陀寺"
          />
        </div>
        <img
          v-if="home.introduce"
          class="bg-img"
          :src="home.introduce.cover"
          alt="南普陀寺简介配图"
          @click="$routerLink({ path: home.introduce.uri })"
        />
        <div class="describe SourceHanSerifCN-Regular">
          <div v-if="home.introduce">
            {{ home.introduce.content }}
          </div>
          <center
            class="read-more SourceHanSerifCN-Regular"
            @click="
              $routerLink({ path: home.introduce.uri })
            "
          >
            了解更多<i class="el-icon-arrow-right"></i>
          </center>
        </div>
      </div>
    </main>
    <!-- 寺院咨讯 -->
    <!--
    <main class="info">
      <div class="box" >
        <div class="txt">
          <img
            src="https://f.nanputuo.com/nanputuo/img/public/sy_bt2@2x.png"
            alt="寺院资讯"
          />
        </div>
        <div class="cards">
          <div class="card-item">
            <center class="title HBKX">最新动态</center>
            <center
              class="info-box"
              :style="{
                backgroundImage: `url(${newDynamicItem.imgUrl})`
              }"
              @click="
                $routerLink({
                  path: `/news/latest?id=1551843364479971330&cid=${newDynamicItem.categoryId}&source=${newDynamicItem.source}&tid=${newDynamicItem.contentId}`
                })
              "
            >
              <div class="detail SourceHanSerifCN-Light">
                <div class="de_box">
                  <span class="tag"
                    >[{{
                      newDynamicItem.categoryName
                    }}]</span
                  >
                  <span>{{ newDynamicItem.title }}</span>
                </div>
              </div>
            </center>
            <div class="line"></div>
            <div class="cell SourceHanSerifCN-Regular">
              <div
                class="cell-item"
                v-for="(item, index) of newDynamicList"
                :key="index"
                @mouseenter="newDynamicItem = item"
                @click="
                  $routerLink({
                    path: `/news/latest?id=1551843364479971330&cid=${item.categoryId}&source=${item.source}&tid=${item.contentId}`
                  })
                "
              >
                <div class="left">
                  <div class="icon">
                    <img
                      src="https://f.nanputuo.com/nanputuo/img/home/资讯小图标.png"
                      alt="资讯小图标"
                    />
                  </div>
                  <div class="content">
                    <span class="tag"
                      >[{{ item.categoryName }}]</span
                    >
                    <span class="toe">{{
                      item.title
                    }}</span>
                  </div>
                </div>
                <div class="time">
                  {{ item.publishTime | formatTimeYYMMDD }}
                </div>
              </div>
            </div>
            <center
              class="read-more SourceHanSerifCN-Regular"
              @click="
                $routerLink({
                  path: '/news/latest?id=1551843364479971330'
                })
              "
            >
              了解更多<i class="el-icon-arrow-right"></i>
            </center>
          </div>
          <div class="card-item">
            <center class="title HBKX">寺院公告</center>
            <center
              class="info-box"
              :style="{
                backgroundImage: `url(${templeNoticeItem.imgUrl})`
              }"
              @click="
                $routerLink({
                  path: `/news/notice?id=1552229461781405697&cid=${templeNoticeItem.categoryId}&source=${templeNoticeItem.source}&tid=${templeNoticeItem.contentId}`
                })
              "
            >
              <div class="detail SourceHanSerifCN-Light">
                <div class="de_box">
                  <span>{{ templeNoticeItem.title }}</span>
                </div>
              </div>
            </center>
            <div class="line"></div>
            <div class="cell SourceHanSerifCN-Regular">
              <div
                class="cell-item"
                v-for="(item, index) of templeNoticeList"
                :key="index"
                @mouseenter="templeNoticeItem = item"
                @click="
                  $routerLink({
                    path: `/news/notice?id=1552229461781405697&cid=${item.categoryId}&source=${item.source}&tid=${item.contentId}`
                  })
                "
              >
                <div class="left">
                  <div class="icon">
                    <img
                      src="https://f.nanputuo.com/nanputuo/img/home/资讯小图标.png"
                      alt="资讯小图标"
                    />
                  </div>
                  <div class="content">
                    <span>{{ item.title }}</span>
                  </div>
                </div>
                <div class="time">
                  {{ item.publishTime | formatTimeYYMMDD }}
                </div>
              </div>
              <center
                class="read-more SourceHanSerifCN-Regular"
                @click="
                  $routerLink({
                    path: '/news/notice?id=1552229461781405697'
                  })
                "
              >
                了解更多<i class="el-icon-arrow-right"></i>
              </center>
            </div>
          </div>
          <div class="card-item">
            <center class="title HBKX">特色活动</center>
            <center
              class="info-box"
              :style="{
                backgroundImage: `url(${newActivityItem.imgUrl})`
              }"
              @click="
                $routerLink({
                  path: `/news/activity?id=1552472724614447105&cid=${newActivityItem.categoryId}&source=${newActivityItem.source}&tid=${newActivityItem.contentId}`
                })
              "
            >
              <div class="detail SourceHanSerifCN-Light">
                <div class="de_box">
                  <span>{{ newActivityItem.title }}</span>
                </div>
              </div>
            </center>
            <div class="line"></div>
            <div class="cell SourceHanSerifCN-Regular">
              <div
                class="cell-item"
                v-for="(item, index) of newActivityList"
                :key="index"
                @mouseenter="newActivityItem = item"
                @click="
                  $routerLink({
                    path: `/news/activity?id=1552472724614447105&cid=${item.categoryId}&source=${item.source}&tid=${item.contentId}`
                  })
                "
              >
                <div class="left">
                  <div class="icon">
                    <img
                      src="https://f.nanputuo.com/nanputuo/img/home/资讯小图标.png"
                      alt="资讯小图标"
                    />
                  </div>
                  <div class="content">
                    <span>{{ item.title }}</span>
                  </div>
                </div>
                <div class="time">
                  {{ item.publishTime | formatTimeYYMMDD }}
                </div>
              </div>
            </div>
            <center
              class="read-more SourceHanSerifCN-Regular"
              @click="
                $routerLink({
                  path: '/news/activity?id=1552472724614447105'
                })
              "
            >
              了解更多<i class="el-icon-arrow-right"></i>
            </center>
          </div>
        </div>
      </div>
    </main>
    -->
    <!-- 弘法利生 -->
    <!--
    <main class="promote">
      <div class="box">
        <div class="txt">
          <img
            src="https://f.nanputuo.com/nanputuo/img/public/sy_bt3@2x.png"
          />
        </div>
        <div class="promote-list">
          <div
            class="promote-item"
            v-for="(item, index) of home.promote"
            :key="index"
            :style="{
              'background-image': `url(${item.bg})`,
              '--bg': `url(${item.cover})`
            }"
            @click="$routerLink({ path: item.uri })"
          >
            <div class="mb"></div>
            <p class="title HBKX">
              <span
                v-for="(t, tIndex) in item.title"
                :key="tIndex"
              >
                {{ t }}
              </span>
            </p>
            <div class="icon">
              <img
                class="logo"
                src="https://f.nanputuo.com/nanputuo/img/home/弘法利生小图标.png"
              />
            </div>
            <div class="see-more">
              <div class="text SourceHanSerifCN-Regular">
                查看更多
              </div>
              <div class="vertical-line"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
    -->
    <RightFixedNav :side="0" />
  </div>
</template>

<script>
import qs from 'qs'
import { selfUrl } from '@/api/config'
import common from '@/api/module/common'
import { mourningSet } from '@/utils/common'
import { mapState, mapMutations } from 'vuex'
import RightFixedNav from '@/components/RightFixedNav'
export default {
  name: 'HomeView', //首页
  components: {
    RightFixedNav
  },
  data() {
    return {
      home: {},
      newDynamicList: [],
      templeNoticeList: [],
      newDynamicItem: {},
      templeNoticeItem: {},
      newActivityList: [],
      newActivityItem: {}
    }
  },
  computed: {
    ...mapState('authAbout', ['token']) //token
  },
  methods: {
    //往vuex设置新token的方法
    ...mapMutations('authAbout', {
      SET_USER_TOKEN: 'SET_USER_TOKEN'
    }),
    async getCodeAndLogin() {
      const search = qs.parse(window.location.search)
      if (search['?code'] && !this.token) {
        try {
          const {
            code,
            msg,
            data: { token } = {}
          } = await common.commonOauth({
            code: search['?code']
          })
          if (!code) {
            //登录成功
            this.SET_USER_TOKEN(token)
            this.$message.success(msg)
            const routeParams = this.$JSONtoObject(
              localStorage.getItem('routeParams') || '{}'
            )
            if (!routeParams.path)
              routeParams.path = '/home'
            const pathParams = { path: '', query: '' }
            Object.keys(routeParams.query).forEach(
              (key, index) => {
                pathParams.query += `${
                  index === 0 ? '' : '&'
                }${key}=${routeParams.query[key]}`
              }
            )
            pathParams.path = `${routeParams.path}${
              pathParams.query ? '?' : ''
            }${pathParams.query}`
            window.location.href = `${selfUrl}/#${pathParams.path}`
          }
        } catch (error) {
          console.error(error || '请求失败')
        }
      }
    },
    async getListById(id, list, item) {
      try {
        const {
          data: { pageList }
        } = await common.commonContentPageId({ id })
        this[list] = pageList
        if (pageList.length) this[item] = pageList[0]
      } catch (error) {
        console.error(error || '请求失败')
      }
    },
    // 最新动态
    getNewDynamic() {
      this.getListById(
        '1551843364479971330',
        'newDynamicList',
        'newDynamicItem'
      )
    },
    // 寺院公告
    getTempleNotice() {
      this.getListById(
        '1552229461781405697',
        'templeNoticeList',
        'templeNoticeItem'
      )
    },
    // 特色活动
    getNewActivity() {
      this.getListById(
        '1552472724614447105',
        'newActivityList',
        'newActivityItem'
      )
    },
    // 首页参数
    async getConfig() {
      try {
        // 首页id： 3
        const { data } = await common.commonConfig(3)
        if (data) {
          this.home = this.$JSONtoObject(data.value)
          this.$bus.$emit(
            'headerCarousels',
            this.home.carousel
          )
          this.home.promote.abbot.bg =
            'https://f.nanputuo.com/nanputuo/img/home/组1.png'
          this.home.promote.could.bg =
            'https://f.nanputuo.com/nanputuo/img/home/弘法利生模块图.png'
          this.home.promote.culture.bg =
            'https://f.nanputuo.com/nanputuo/img/home/组84.png'
          this.home.promote.online.bg =
            'https://f.nanputuo.com/nanputuo/img/home/组85.png'
          this.home.promote.learn.bg =
            'https://f.nanputuo.com/nanputuo/img/home/组86.png'
          this.home.promote.kindness.bg =
            'https://f.nanputuo.com/nanputuo/img/home/图层1171.png'
          this.home.promote.public.bg =
            'https://f.nanputuo.com/nanputuo/img/home/图层1173.png'
          await this.$nextTick()
          if (this.home.mourning) mourningSet.add()
          else mourningSet.remove()
        }
      } catch (error) {
        console.error(error || '请求失败')
      }
    },
    async init() {
      await this.getCodeAndLogin()
      this.getConfig()
      this.getNewDynamic()
      this.getTempleNotice()
      this.getNewActivity()
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    mourningSet.remove(this.$route.path)
  }
}
</script>
<style lang="less" scoped>
.home_view {
  main {
    .box {
      width: 1600px;
      margin: 0 auto;
      h1 {
        font-size: 56px;
        color: @font-color-695557;
        text-align: center;
        margin: 0 auto;
        width: 256px;
        height: 79px;
        background-image: url('https://f.nanputuo.com/nanputuo/img/home/标题云纹.png');
        background-repeat: no-repeat;
        background-size: 72px 25px;
        background-position: 53px 44px;
        img {
          width: 14px;
          position: relative;
          left: -25px;
          top: 5px;
        }
      }
      .logo {
        width: 90px;
        display: block;
        margin: 0 auto;
      }
      .txt {
        display: flex;
        justify-content: center;
      }
    }
  }
  .temple {
    background-color: @main-color-F9F9F5;
    padding-top: 75px;
    padding-bottom: 43px;
    .box {
      .txt {
        margin-bottom: 31px;
      }
      .bg-img {
        display: block;
        margin: 0 auto;
        width: 1600px;
        height: 653px;
      }
      .describe {
        padding: 36px 67px 30px 67px;
        line-height: 22px;
        color: @font-color-695557;
        background-color: #fdfdfd;
        padding-bottom: 20px;
        .read-more {
          font-size: 16px;
          color: @main-color-A45E44;
          margin-top: 30px;
          cursor: pointer;
          i {
            margin-left: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .info {
    padding-top: 75px;
    padding-bottom: 38px;
    .box {
      .txt {
        margin-bottom: 47px;
      }
      .cards {
        display: flex;
        justify-content: space-between;
        .card-item {
          position: relative;
          width: 520px;
          height: 650px;
          padding: 36px 15px;
          background-color: @main-color-F9F9F5;
          cursor: pointer;
          .title {
            font-size: 34px;
            color: @font-color-695557;
            margin-bottom: 29px;
          }
          .info-box {
            height: 306px;
            position: relative;
            background-position: center center;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            .detail {
              width: 100%;
              height: 74px;
              position: absolute;
              background: rgba(251, 251, 251, 0.8);
              left: 0;
              bottom: 0;
              padding: 13px 37px 11px 19px;
              text-align: left;
              line-height: 24px;
              overflow: hidden;
              .de_box {
                height: 50px;
                overflow: hidden;
              }
              span {
                color: @font-color-695557;
                font-size: 18px;
              }
              .tag {
                width: 90px;
                margin-right: 6px;
                color: @main-color-A45E44;
              }
            }
          }
          .line {
            margin: 25px 0 30px 0;
            border-top: 1px solid @main-color-BFB2AA;
          }
          .cell {
            height: 120px;
            overflow: hidden;
            .cell-item {
              display: flex;
              justify-content: space-between;
              font-size: 18px;
              margin-bottom: 32px;
              &:last-of-type {
                margin-bottom: 0;
              }
              .left {
                flex: 1;
                display: flex;
                .icon {
                  margin-right: 15px;
                  img {
                    width: 14px;
                  }
                }
                .content {
                  flex: 1;
                  width: 318px;
                  margin-right: 15px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  .tag {
                    color: @main-color-A45E44;
                  }
                  span {
                    color: @font-color-695557;
                  }
                }
              }
              .time {
                color: @font-color-695557;
              }
            }
          }
          .read-more {
            position: absolute;
            left: 50%;
            bottom: 39px;
            transform: translateX(-50%);
            font-size: 16px;
            color: @main-color-A45E44;
            cursor: pointer;
            i {
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .promote {
    background-color: @main-color-F9F9F5;
    padding-top: 75px;
    padding-bottom: 54px;
    .promote-list {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;
      .promote-item {
        width: 180px;
        height: 728px;
        position: relative;
        cursor: pointer;
        border: 2px solid @main-color-BFB2AA;
        background-repeat: no-repeat;
        background-position: bottom left;
        transition-property: width;
        transition-duration: 0.3s;
        &:hover {
          width: 363px;
          background-size: 363px 728px;
          background-image: var(--bg) !important;
          .mb {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
          }
          .title {
            color: @main-color-FBFBF7;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin-top: 0;
            z-index: 20;
          }
          .icon {
            display: none;
          }
          .see-more {
            .text {
              color: #fafaf6;
            }
            .vertical-line {
              background-color: @main-color-FBFBF7;
            }
          }
        }
        .title {
          width: 30px;
          height: 137px;
          margin: 141px auto 0;
          font-size: 34px;
          color: @font-color-695557;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .icon {
          img {
            position: relative;
            left: 2px;
            top: 20px;
            width: 20px;
          }
        }
        .see-more {
          position: absolute;
          right: 12px;
          bottom: 0;
          .text {
            width: 18px;
            height: 79px;
            font-size: 18px;
            color: @font-color-695557;
          }
          .vertical-line {
            width: 1px;
            height: 114px;
            background-color: @main-color-BFB2AA;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
